import { NotificationDetailPage as LegacyNotificationDetailPage } from "../../dashboard/notifications/notification-detail";

/**
 * Détail d'une notification dans l'espace utilisateur.
 *
 * Le composant historique (déjà premium : lecture enrichie, archives,
 * suppression) est réutilisé tel quel — pattern strangler : un seul
 * point d'adaptation, zéro duplication.
 */
export const UserSpaceNotificationDetailPage = () => <LegacyNotificationDetailPage />;
